// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import OffersCreatePage from './offers-create-page';
// assets
//

// ----------------------------------------------------------------------

export default function Createoffers() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <OffersCreatePage />
        </Container >
    );
}
